import { globalStyle, style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const updatingContentStyles = style({
  display: "grid",
  gap: vars.space.m,
});

export const updatingContentHeaderStyles = style({
  display: "grid",
  gap: vars.space.m,
  marginBottom: vars.space.s,
});

// Pulse style overrides
export const updatingContentArticleStyles = style({});

// Combine related selectors for better efficiency
globalStyle(
  `${updatingContentArticleStyles} [class*=col-], ${updatingContentArticleStyles} .standardArticle`,
  {
    margin: 0,
  },
);

globalStyle(`${updatingContentArticleStyles} [class*=col-]`, {
  padding: 0,
});

globalStyle(`${updatingContentArticleStyles} .standardArticle > p`, {
  display: "none",
});

// More efficient li styling - apply padding to all li elements
globalStyle(`${updatingContentArticleStyles} li`, {
  marginInlineStart: vars.space.xs,
  paddingBottom: vars.space.xs,
  listStyleType: "disc",
});

// Remove padding from last child instead of using :not(:last-child)
globalStyle(`${updatingContentArticleStyles} li:last-child`, {
  paddingBottom: 0,
});

globalStyle(`${updatingContentArticleStyles} a`, {
  color: "inherit",
  fontFamily: vars.fonts.bold,
});
